import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { first } from 'rxjs/operators';
import { UserService } from '../../../core/user/user.service';
import { AlertService } from '../../../shared/alert/alert.service';
import { WalletTransaction } from '../../../models/wallet-transaction';
import { MatPaginator } from '@angular/material/paginator';

@Component({
    selector: 'app-my-wallet',
    templateUrl: './my-wallet.component.html',
    styleUrls: ['./my-wallet.component.scss']
})
export class MyWalletComponent implements OnInit {
    /** table  **/
    public walletTransactionList: WalletTransaction[] = [];

    displayedColumns: string[] = ['currency', 'amount', 'createdAt', 'type'];
    dataSource;
    wallet;
    alertOptions = {
        autoClose: true,
        keepAfterRouteChange: false
    };
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    constructor(
        private userService: UserService,
        private alertService: AlertService
    ) {}

    ngOnInit() {
        this.getUserWallet();
    }

    getUserWallet() {
        this.userService
            .getUserWallet()
            .pipe(first())
            .subscribe({
                next: resp => {
                    this.wallet = resp;
                    this.walletTransactionList = this.wallet.walletTransactionList;
                    this.dataSource = new MatTableDataSource<WalletTransaction>(
                        this.walletTransactionList
                    );
                    this.dataSource.paginator = this.paginator;
                },
                error: error => {
                    this.alertService.error('Error: ' + error, this.alertOptions);
                }
            });
    }
}
